'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1riq2iDsCRSmp9Z3EqQpiB-uhUtbtG2fB2t9ekenee-4';